// Jobs-ladder titles (GDD §4.1), keyed by tier — UI-side data, never a string
// hardcoded in JSX (§10's "every constant lives in data" spirit; the wage
// beside the title already reads P.wages[st.J], and the two must move together
// the moment promotions surface in M5).

export const JOB_TITLES: readonly string[] = [
  'Casual labour',
  'Trade assistant',
  'Technician',
  'Specialist',
  'Senior specialist',
  'Principal',
  'Master',
];
